export const titleModal: Record<string, string> = {
  nmIds: 'Артикулы продукта на Wildberries',
  skus: 'Артикулы продукта на Ozon'
};
